<div class="search-users-filters">
  <button *ngIf="appliedFilterCount > 0" tuiButton type="button" appearance="mono" size="m" (click)="onReset()">
    <span class="tui-space_right-2">{{ 'components.searchUsers.buttons.clearFilters' | translate }}</span>

    <tui-badge appearance="primary" class="search-users-filters__badge">{{ appliedFilterCount }}</tui-badge>
  </button>

  <button
    tuiButton
    class="search-users-filters__show-dropdown-btn"
    type="button"
    appearance="outline-grayscale"
    tuiAppearanceMode="checked"
    [size]="'m'"
    [iconStart]="'@tui.filter'"
    [iconEnd]="(open$ | async) ? '@tui.chevron-up' : '@tui.chevron-down'"
    [tuiDropdown]="dropdownContent"
    [tuiDropdownManual]="(open$ | async) ?? false"
    [tuiDropdownMaxHeight]="561"
    [tuiDropdownAlign]="'right'"
    (click)="onToggleDropdown()"
    (tuiObscured)="onObscured($event)"
    (tuiActiveZoneChange)="onActiveZone($event)"
  >
    {{ 'components.searchUsers.buttons.filters' | translate }}
  </button>

  <!-- <ng-template #icon>
    <tui-icon
      [style.border-width.rem]="0.25"
      icon="@tui.chevron-down"
      class="search-users-filters__dropdown_arrow"
      [class.search-users-filters__dropdown_arrow--open]="(open$ | async) ?? false"
    ></tui-icon>
  </ng-template> -->
</div>

<ng-template #dropdownContent>
  <div class="search-users-filters__dropdown">
    <div class="search-users-filters__dropdown_title">
      <span class="tui-text_body-m" [style.font-weight]="800">
        {{ 'components.searchUsers.buttons.filters' | translate }}
      </span>

      <button tuiButton type="button" appearance="primary" size="s" (click)="onApply()" [disabled]="!isPossibleToApply">
        {{ 'components.searchUsers.buttons.apply' | translate }}
      </button>
    </div>

    <tui-accordion class="search-users-filters__dropdown_accordion" [rounded]="false">
      <tui-accordion-item [borders]="null" size="s" *ngFor="let storeItem of getStoreValues()">
        <div
          filter-accordion-title
          [title]="getTitle(storeItem.title) | translate"
          [count]="storeItem.result.length"
        ></div>

        <ng-template tuiAccordionItemContent>
          <div
            *ngIf="storeItem.type === 'checkbox'"
            filter-accordion-content
            [autofocus]="!isMobilePlatform"
            [items]="storeItem.items"
            [(result)]="storeItem.result"
            (resultChange)="onCheckFiltersCount()"
            [variant]="storeItem.variant ?? 'short'"
          ></div>

          <div *ngIf="storeItem.type === 'field'">
            <app-filter-accordion-content-fields
              [size]="'m'"
              [items]="storeItem.items"
              [(result)]="storeItem.result"
              (resultChange)="onCheckFiltersCount()"
            ></app-filter-accordion-content-fields>
          </div>
        </ng-template>
      </tui-accordion-item>
    </tui-accordion>
  </div>
</ng-template>
